import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import { sanitize } from "dompurify";

import { selectSetting } from "../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";

const PolicyProcedures = (): React.JSX.Element => {
    const pageContent = useAppSelector(state =>
        selectSetting(state, "majorybl_policy_procedures"),
    )?.setting;

    return (
        <div data-testid="policyContent">
            <Container>
                <Row>
                    <Col>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: sanitize(pageContent),
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default PolicyProcedures;
